import { queryOptions, useQuery } from '@tanstack/react-query';

import type { Quotation } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { findDataInQueryCache } from '../utils';
import { quotationSchema } from './schemas';

export const quotationQueryOptions = (id: number) => {
  const cachedQuotation = findDataInQueryCache<Quotation>(
    [...QueryKeys.quotations.index.root, 'metadata'],
    (quotation) => quotation.id === id,
  );

  return queryOptions({
    queryKey: QueryKeys.quotations.show.id(id),
    queryFn: async () => {
      const { data: quotation } = await fetchJson(`/quotations/${id}`, {
        schema: apiResourceSchema(quotationSchema),
      });

      return quotation;
    },
    initialData: cachedQuotation?.data,
    initialDataUpdatedAt: cachedQuotation?.state.dataUpdatedAt,
    staleTime: 60 * 1000,
  });
};

export const useQuotation = (id: number) => {
  return useQuery(quotationQueryOptions(id));
};
